import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created. Welcome to the Academy.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <AuthShell heading="Create your account" sub="Enrol in courses and track your growth.">
      <form onSubmit={submit} className="mt-10 space-y-4" data-testid="register-form">
        <Input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" className="bg-ink-paper border-gold-500/25 text-white placeholder:text-white/40 py-6" />
        <Input required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className="bg-ink-paper border-gold-500/25 text-white placeholder:text-white/40 py-6" />
        <Input required type="password" placeholder="Password (min. 6 characters)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className="bg-ink-paper border-gold-500/25 text-white placeholder:text-white/40 py-6" />
        <Button type="submit" disabled={busy} data-testid="register-submit" className="w-full bg-gold-500 text-ink hover:bg-gold-400 font-semibold py-6">
          {busy ? "Creating…" : "Create Account"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-white/60">
        Already have an account? <Link to="/login" className="text-gold-400 hover:underline" data-testid="to-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
